import React from "react";

const Layout = ({ children }) => {
  return (
    <div className="max-w-[90rem] mx-auto px-4 sm:px-6 md:px-8 ">
      {children}
    </div>
  );
};

export default Layout;
